import {useEffect, useState} from "react";

export const useModifierKeys = (onModifierChange = null) => {
  const [modifiers, setModifiers] = useState({
    shift: false,
    ctrl: false,
    alt: false,
    meta: false,
  });

  useEffect(() => {
    onModifierChange && onModifierChange(modifiers);
  }, [modifiers])

  useEffect(() => {
    const handleKeyDown = (event) => {
      setModifiers({
        shift: event.shiftKey,
        ctrl: event.ctrlKey,
        alt: event.altKey,
        meta: event.metaKey,
      });
    };

    const handleKeyUp = (event) => {
      setModifiers({
        shift: event.shiftKey,
        ctrl: event.ctrlKey,
        alt: event.altKey,
        meta: event.metaKey,
      });
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, []);

  return modifiers;
};
